// @flow

import React from 'react'
import { useWarnings } from '@bfg/effects/warnings'

export const Warnings = () => {
  const warningsHandler = useWarnings()
  return (
    <div>
      {
        warningsHandler.warnings !== null
        && (
          <p className="warning">
            {warningsHandler.warnings}
            <a onClick={warningsHandler.dismissWarnings}
               className="close">&#9447;</a>
          </p>
        )
      }
    </div>
  )
}
